import styled from 'styled-components';
import Popover from "../Popover/Popover";
export default styled(Popover).withConfig({
  displayName: "PopoverDesktop",
  componentId: "ik33zt-0"
})(["min-width:180px;"]);